// Contact — one address, and what it is for.
import './Info.css';

const EMAIL = 'Cinemorehq@gmail.com';

export function Contact() {
  return (
    <main className="column info">
      <h1 className="info-title">Contact</h1>

      <p className="info-line">
        Feedback, a puzzle that looks wrong, or anything that does not work — this is the
        address. It is read by one person, so a reply may take a few days.
      </p>

      <p className="info-line info-email">
        <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
      </p>

      <section className="info-section">
        <h2 className="heading info-heading">Reporting a problem</h2>
        <p className="info-line">
          If something is broken, the puzzle number and what you were doing when it happened are
          the two things that make it findable — for example, "Running Order #14, the board went
          blank after my second guess."
        </p>
      </section>
    </main>
  );
}
